import React from "react";
import "./ContactPage.css";
import contactImage from "../../assets/logos/logo.webp";
import Navbar from "../../components/NavBar/Navbar";
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Kontakty | Divadlo Di</title>
        <meta
          name="description"
          content="Chceš nás kontaktovat? Rádi ti odpovíme."
        />
        <meta
          name="keywords"
          content="kontakty, divadlo, divadlo DI, DI, divadelní hry"
        />
        <link rel="canonical" href="https://www.divadlodi.cz/#/kontakty" />
      </Helmet>
      <Navbar />
      <div className="contact-container">
        <div className="contact-image">
          <img src={contactImage} alt="Contact" loading="lazy" />
        </div>
        <div className="contact-details">
          <div className="contact-section">
            <h2>O nás</h2>
            <p>
              představení divadla Di, pronájmy, rezervace, Divan - představení,
              <br />
              Dr. ZDIV - přihlášky, TV VV, Výstavy ve výloze, přednášky,
              koncerty, kulturní akce a mnohé další...{" "}
            </p>
          </div>
          <div className="contact-section">
            <h2>Kontakty</h2>
            <p>
              <strong>Adresa:</strong> Pražská 8, Vysoké Mýto 566 01
            </p>
            <p>
              <strong>Telefonní číslo:</strong> +420 777 076 901 (Adéla
              Pellarová)
            </p>
            <p>
              <strong>Email:</strong> divadlodi@divadlodi.cz
            </p>
            <h2>Produkce</h2>
            <p>
              <strong>Telefonní číslo:</strong> +420 777 013 531 (Amálie
              Popelářová)
            </p>
            <p>
              <strong>Email:</strong> produkce@divadlodi.cz
            </p>
            <a
              href="https://www.instagram.com/divadlo_di?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              className="contact-ig fa-bounce"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Instagram </strong>
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.facebook.com/people/Divadeli%C3%A9r-Vysok%C3%A9-M%C3%BDto/61580111814101/"
              className="contact-fb fa-bounce"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Facebook </strong>
              <i className="fab fa-facebook"></i>
            </a>
          </div>
          <div className="contact-section map">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2567.0283958728623!2d16.15694027684871!3d49.95456982294376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470dc172cbafc7a1%3A0xe181fc42e8afb1b6!2sDivadeli%C3%A9r!5e0!3m2!1scs!2scz!4v1718886644593!5m2!1scs!2scz"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
